/**
 * Browsers treat the mouse wheel as a value stepper on a focused
 * `input[type="number"]`, so scrolling the page after clicking into a field
 * like Increment/Decrement, Start Price or Qty silently edits the amount.
 *
 * Blurring the field on the first wheel tick drops that behaviour while
 * leaving the page scroll itself untouched: the blur runs before the
 * browser's default wheel action, so the value never changes.
 */
const isFocusedNumberInput = (element) =>
  element instanceof HTMLInputElement &&
  element.type === "number" &&
  element === document.activeElement;

const handleWheel = (event) => {
  if (isFocusedNumberInput(event.target)) {
    event.target.blur();
  }
};

/**
 * Registers the guard for the whole document and returns a cleanup function.
 */
const preventNumberInputScroll = () => {
  document.addEventListener("wheel", handleWheel, { passive: true });

  return () => {
    document.removeEventListener("wheel", handleWheel);
  };
};

export default preventNumberInputScroll;
